import { render } from "./TotalLTL.vue?vue&type=template&id=5482702a&scoped=true"
import script from "./TotalLTL.vue?vue&type=script&lang=js"
export * from "./TotalLTL.vue?vue&type=script&lang=js"

import "./TotalLTL.vue?vue&type=style&index=0&id=5482702a&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5482702a"]])

export default __exports__